<template>
  <div class="MyInput">
    <label>{{title}}</label>
    <input name="" :type="type" :value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="error?error:placeholder" :class="{error: error}" :style="inputStyle" :autocomplete="disfill?'off':'on'" />
  </div>
</template>

<script>
 export default {
   name: 'MyInput',
   props: ['title', 'value', 'type', 'placeholder', 'inputStyle', 'error', 'disfill']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyInput {
   width: 100%;
   display: flex;
   line-height: 1.35vw;
 }

 .MyInput > label {
   display: flex;
   align-items: center;
   justify-content: flex-end;
   font-size: 0.83vw;
   flex-basis: 100px;
   margin-right: 30px;
 }

 .MyInput > input{
   flex-grow: 1;
   border: 1px solid #E2E8ED;
   border-radius: 4px;
   font-size: 0.83vw;
   line-height: 1.35vw !important;
   height: 2.8vw;
   box-sizing: border-box;
   padding-left: 0.78vw;
 }

 .MyInput > input.error{
   border: 1px solid red;
   box-shadow: red 0 0 10px;
 }

 input.error::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
   color: red;
   opacity: 1; /* Firefox */
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .MyInput > input{
   font-size: 14px;
   line-height: 30px !important;
   height: 34px;
   }
 }
</style>
